import React from "react";

const CheckCircle = ({ width = 23, height = 23, fill, style, ...rest }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 23 23" fill="none" style={style}>
      <path
        d="M10.1591 0.430664H11.8809C12.2369 0.487955 12.5932 0.545246 12.9503 0.601772C17.2024 1.30301 20.8225 4.71714 21.7475 8.91349C21.8678 9.4589 21.9434 10.0146 22.0401 10.5654V12.2841C22.0168 12.355 21.9988 12.4275 21.9862 12.501C21.7383 14.9634 20.764 17.1022 19.0808 18.9134C16.0062 22.2236 11.1682 23.3641 6.92108 21.6163C3.43973 20.1806 1.24244 17.5949 0.299056 13.9608C0.156594 13.4119 0.0977759 12.8413 0 12.2803V10.5615C0.0572906 10.206 0.114581 9.85 0.171489 9.49442C0.869671 5.25988 4.29412 1.64943 8.50269 0.7217C9.05 0.603299 9.60687 0.527294 10.1591 0.430664ZM11.0086 20.5821C16.0463 20.5943 20.1865 16.4797 20.2037 11.4404C20.2224 6.41676 16.1029 2.28803 11.0456 2.26205C6.00405 2.23608 1.84094 6.37437 1.83635 11.4175C1.83215 16.4457 5.95975 20.5698 11.0086 20.5821Z"
        fill="white"
      />
      <path
        d="M10.4874 12.8195L13.0937 9.70177C13.552 9.15292 14.0054 8.59873 14.4752 8.05944C14.6043 7.91351 14.7767 7.8128 14.9672 7.77208C15.1578 7.73136 15.3563 7.75277 15.5338 7.83317C15.7113 7.91357 15.8583 8.04873 15.9533 8.21882C16.0483 8.38891 16.0863 8.58497 16.0617 8.77824C16.0354 8.95601 15.963 9.12378 15.8517 9.26483C14.3349 11.093 12.8121 12.9167 11.2833 14.7357C10.8865 15.2074 10.3159 15.2188 9.87779 14.7857C8.97515 13.893 8.07658 12.9965 7.18208 12.0961C6.78754 11.6993 6.7841 11.1413 7.1584 10.77C7.5327 10.3988 8.08727 10.4087 8.48792 10.8063C9.15097 11.464 9.80484 12.1313 10.4874 12.8195Z"
        fill="white"
      />
    </svg>
  );
};

CheckCircle.defaultProps = {
  width: 23,
  height: 23,
  fill: "black",
};

export default CheckCircle;
